import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";

const Loader = ({destination = "/login"}) => {
  const [countdown, setCountdown] = useState(10);
  const navigate = useNavigate();
  useEffect(() => {
    if (countdown > 0){
      const timer = setInterval(() => {
        setCountdown((prevCountdown) => prevCountdown - 1);
      }, 1000);
      return () => clearInterval(timer);
    } else {
      navigate(destination)
      // navigate("/peserta/logout");
      return;
      // console.log("waktu habis");
    }
  })
  return (
    <div className="flex flex-col justify-center items-center h-screen">
      <div className="flex space-x-2 mb-6">
        <style>
          {`
            @keyframes threeDotsBounce {
              0%, 80%, 100% {
                transform: scale(0);
              }
              40% {
                transform: scale(1.0);
              }
            }
            .dot-bounce {
              width: 1rem; /* 16px */
              height: 1rem; /* 16px */
              background-color: #4F8382; /* Ganti dengan warna yang Anda inginkan, contoh: biru */
              border-radius: 100%;
              display: inline-block;
              animation: threeDotsBounce 1.4s infinite ease-in-out both;
            }
          `}
        </style>
        <div className="dot-bounce" style={{ animationDelay: '-0.32s' }}></div>
        <div className="dot-bounce" style={{ animationDelay: '-0.16s' }}></div>
        <div className="dot-bounce"></div>
      </div>
      <p className="text-xl text-gray-700">Silakan Tunggu ...</p>
    </div>
  );
};

export default Loader;
